import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-717c462a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "footer items-in-column"
}
const _hoisted_2 = { class: "container items-in-column" }
const _hoisted_3 = { class: "footer__top-block" }
const _hoisted_4 = { class: "footer__top-block-docs" }
const _hoisted_5 = { class: "items-in-line footer__top-block-socials" }
const _hoisted_6 = { class: "footer__bottom-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__bottom-block-logo" }, [
  /*#__PURE__*/_createTextVNode("Мой "),
  /*#__PURE__*/_createElementVNode("span", null, "ИЖС")
], -1))
const _hoisted_8 = { class: "footer__bottom-block-contacts" }
const _hoisted_9 = { class: "items-in-line gap--10 footer__bottom-block-hover" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:+79215810509" }, "8 (921) 581-05-09", -1))
const _hoisted_11 = { class: "items-in-line gap--10 footer__container-hover" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:bs1@banki.shop" }, "bs1@banki.shop", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const socials = [
  {
    id: 'vk',
    icon: require('@/assets/img/footer/icon-vk.svg'),
  },
  {
    id: 'tg',
    icon: require('@/assets/img/footer/icon-tg.svg'),
  },
  {
    id: 'whatsapp',
    icon: require('@/assets/img/footer/icon-wapp.svg'),
  },
  {
    id: 'youtube',
    icon: require('@/assets/img/footer/icon-yt.svg'),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_divider = _resolveComponent("base-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'juristicDocuments' },
            class: "pointer underline footer__top-block-doc"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Юридические документы ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (social) => {
            return _createVNode(_component_base_image, {
              key: social.id,
              alt: social.id,
              src: social.icon,
              class: "pointer tertiaryLightColorFilter",
              contain: "",
              height: "30",
              width: "30"
            }, null, 8, ["alt", "src"])
          }), 64))
        ])
      ]),
      _createVNode(_component_base_divider, { color: "#a79f9a" }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: { name: 'main' },
          class: "items-in-line gap--5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/footer/icon-map.svg'),
              contain: "",
              height: "30",
              name: "logo",
              width: "26"
            }, null, 8, ["src"]),
            _hoisted_7
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/footer/icon-call.svg'),
              alt: "phone",
              class: "tertiaryLightColorFilter",
              contain: "",
              height: "20",
              width: "20"
            }, null, 8, ["src"]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_base_image, {
              src: require('@/assets/img/footer/icon-mail.svg'),
              alt: "email",
              class: "tertiaryLightColorFilter",
              contain: "",
              height: "20",
              width: "20"
            }, null, 8, ["src"]),
            _hoisted_12
          ])
        ])
      ])
    ])
  ]))
}
}

})